/*
  cb-sort.js – eigenes Sortiermenü statt des System-Aufklappmenüs.
  Das echte <select name="sort_by"> bleibt im Formular (unsichtbar) und wird nur gesetzt; die Filterlogik
  in facets.js (Formular-Ereignis „input“) übernimmt wie bisher das Laden.
  Desktop (#SortByBar): „Sortieren: <Wert> ⌄“ mit eigener Liste (weiße Karte, aktive Option mit blauem Haken).
  Handy (#SortByMobile, im Filter-Fenster): Auswahl-Liste wie bei den Filtern.
*/
(function () {
  var HAKEN = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var PFEIL = '<svg class="cb-sort__chev" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  function optionen(select) {
    var alle = Array.prototype.map.call(select.options, function (o) {
      return { value: o.value, label: o.textContent.trim() };
    });
    /* In Kollektionen (erkennbar an „Größter Rabatt“) bringt „Am relevantesten“ nichts → weglassen, außer aktiv */
    var kollektion = alle.some(function (o) { return o.value === 'manual'; });
    return alle.filter(function (o) { return !(kollektion && o.value === 'most-relevant' && select.value !== o.value); });
  }

  function setzen(select, value) {
    if (select.value === value) return;
    /* Desktop- und Handy-Auswahl gleich halten (sonst zeigt die jeweils andere den alten Wert) */
    document.querySelectorAll('select[name="sort_by"]').forEach(function (s) {
      if (s !== select && s.value !== value) { s.value = value; s.dispatchEvent(new Event('cb-sort-sync')); }
    });
    select.value = value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function esc(s) {
    return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* ── Desktop: Aufklappmenü ── */
  function menue(select, wrap) {
    var box = document.createElement('div');
    box.className = 'cb-sort';
    var id = 'cb-sort-liste-' + select.id;
    box.innerHTML =
      '<button type="button" class="cb-sort__btn" aria-haspopup="listbox" aria-expanded="false" aria-controls="' + id + '">' +
        '<span class="cb-sort__pre">Sortieren:</span>' +
        '<span class="cb-sort__wert"></span>' + PFEIL +
      '</button>' +
      '<ul class="cb-sort__liste" id="' + id + '" role="listbox" tabindex="-1" hidden></ul>';
    wrap.appendChild(box);
    var btn = box.querySelector('.cb-sort__btn');
    var liste = box.querySelector('.cb-sort__liste');

    function zeichnen() {
      var akt = select.value;
      box.querySelector('.cb-sort__wert').textContent = (select.options[select.selectedIndex] || {}).textContent || '';
      liste.innerHTML = optionen(select).map(function (o) {
        var an = o.value === akt;
        return '<li role="option" class="cb-sort__opt' + (an ? ' is-aktiv' : '') + '" data-value="' + esc(o.value) +
          '" aria-selected="' + an + '" tabindex="-1"><span>' + esc(o.label) + '</span>' + (an ? HAKEN : '') + '</li>';
      }).join('');
    }
    function auf() {
      zeichnen();
      liste.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      (liste.querySelector('.is-aktiv') || liste.firstElementChild).focus();
    }
    function zu(fokus) {
      liste.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (fokus) btn.focus();
    }
    btn.addEventListener('click', function () { liste.hidden ? auf() : zu(); });
    liste.addEventListener('click', function (e) {
      var li = e.target.closest('.cb-sort__opt');
      if (!li) return;
      zu(true);
      setzen(select, li.dataset.value);
      zeichnen();
    });
    liste.addEventListener('keydown', function (e) {
      var li = document.activeElement.closest && document.activeElement.closest('.cb-sort__opt');
      if (e.key === 'Escape') { e.preventDefault(); zu(true); }
      else if (e.key === 'ArrowDown' && li && li.nextElementSibling) { e.preventDefault(); li.nextElementSibling.focus(); }
      else if (e.key === 'ArrowUp' && li && li.previousElementSibling) { e.preventDefault(); li.previousElementSibling.focus(); }
      else if ((e.key === 'Enter' || e.key === ' ') && li) { e.preventDefault(); li.click(); }
      else if (e.key === 'Tab') { zu(); }
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) zu(); });
    select.addEventListener('change', zeichnen);
    select.addEventListener('cb-sort-sync', zeichnen);
    zeichnen();
  }

  /* ── Handy: Liste im Filter-Fenster ── */
  function mobilListe(select, wrap) {
    var box = document.createElement('div');
    box.className = 'cb-sort-m';
    box.setAttribute('role', 'radiogroup');
    box.setAttribute('aria-label', 'Sortieren');
    wrap.appendChild(box);
    function zeichnen() {
      box.innerHTML = optionen(select).map(function (o) {
        var an = o.value === select.value;
        return '<button type="button" role="radio" aria-checked="' + an + '" class="cb-sort-m__opt' + (an ? ' is-aktiv' : '') +
          '" data-value="' + esc(o.value) + '"><span class="cb-sort-m__radio" aria-hidden="true"></span>' + esc(o.label) + '</button>';
      }).join('');
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.cb-sort-m__opt');
      if (!b) return;
      setzen(select, b.dataset.value);
      zeichnen();
    });
    select.addEventListener('change', zeichnen);
    select.addEventListener('cb-sort-sync', zeichnen);
    zeichnen();
  }

  function init() {
    var bar = document.getElementById('SortByBar');
    if (bar && !bar.dataset.cbSort) {
      bar.dataset.cbSort = '1';
      var wrapB = bar.closest('.thb-filter-sort');
      wrapB.classList.add('cb-sort-an');
      menue(bar, wrapB);
    }
    var mob = document.getElementById('SortByMobile');
    if (mob && !mob.dataset.cbSort) {
      mob.dataset.cbSort = '1';
      var wrapM = mob.closest('.thb-filter-sort');
      wrapM.classList.add('cb-sort-an');
      mobilListe(mob, wrapM);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('facets:updated', init);
})();
